export const FIXED_AMOUNT_OPTION = '固定金额';

export const normalizePartialPaymentOption = (value) => (value === '预付款' ? FIXED_AMOUNT_OPTION : value);

export const readFixedPayment = (source) => {
	if (source?.fixedPayment != null && source.fixedPayment !== '') return Number(source.fixedPayment) || 0;
	return Number(source?.prePayment) || 0;
};

export const readFixedBalance = (source) => {
	if (source?.fixedBalance != null && source.fixedBalance !== '') return Number(source.fixedBalance) || 0;
	return Number(source?.prePaymentBalance) || 0;
};

export const toCents = (value) => {
	const amount = Number(value);
	if (!Number.isFinite(amount)) return 0;
	return Math.round(amount * 100);
};

export const derivePaymentPercent = (amount, totalPrice) => {
	const total = Number(totalPrice);
	if (!Number.isFinite(total) || total <= 0) return 0;
	return Math.round((Number(amount) / total) * 10000) / 100;
};

export const partialPaymentFormValues = (source, isPartialPayment) => {
	if (!isPartialPayment) {
		return {
			prePaymentOption: '百分比',
			prePaymentPercent: 0,
			percentPayment: 0,
			percentBalance: 0,
			fixedPayment: 0,
			fixedBalance: 0,
		};
	}
	return {
		prePaymentOption: normalizePartialPaymentOption(source?.prePaymentOption) || '百分比',
		prePaymentPercent: Number(source?.prePaymentPercent) || 0,
		percentPayment: Number(source?.percentPayment) || 0,
		percentBalance: Number(source?.percentBalance) || 0,
		fixedPayment: readFixedPayment(source),
		fixedBalance: readFixedBalance(source),
	};
};

export const isFixedAmountOption = (value) => normalizePartialPaymentOption(value) === FIXED_AMOUNT_OPTION;
